import { Alert } from "@mui/material";
import TypingIndicator from "./TypingIndicator";

export type ChatResponseStatus = "queued" | "responding" | "completed" | "failed" | "stalled";

export default function ChatActivity({ status, responding = false, name = "Randol" }: { status?: string; responding?: boolean; name?: string }) {
  if (status === "failed")
    return (
      <Alert severity="warning" role="status">
        The assistant could not complete its response.
      </Alert>
    );
  if (status === "stalled")
    return (
      <Alert severity="info" role="status">
        The response is taking longer than expected. Check for updates before sending again.
      </Alert>
    );
  return responding || status === "queued" || status === "responding" ? <TypingIndicator name={name} /> : null;
}
